// extracted by mini-css-extract-plugin
export default {"makerGrey":"#626262","container":"app_container__TveDd"};